import React from 'react';
import { Link } from 'react-router-dom';

const TRAVEL_CARDS = [
  {
    title: 'Flights',
    desc: 'Find the best flight deals to the conference location.',
    link: 'https://expedia.com/affiliate/eOxf83M',
    linkText: 'Search Flights',
    color: 'bg-blue-50 dark:bg-blue-900/20',
    iconColor: 'text-blue-600 dark:text-blue-400',
    iconBg: 'bg-blue-100 dark:bg-blue-900/30',
    icon: 'M12 19l9 2-9-18-9 18 9-2zm0 0v-8',
  },
  {
    title: 'Hotels',
    desc: 'Special conference rates at partner hotels. Book your stay today.',
    link: 'https://expedia.com/affiliate/eOxf83M',
    linkText: 'Search Hotels',
    color: 'bg-green-50 dark:bg-green-900/20',
    iconColor: 'text-green-600 dark:text-green-400',
    iconBg: 'bg-green-100 dark:bg-green-900/30',
    icon: 'M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6',
  },
  {
    title: 'Car Rentals',
    desc: 'Rent a car for convenient travel to and from the venue.',
    link: 'https://expedia.com/affiliate/PIjuiFu',
    linkText: 'Search Cars',
    color: 'bg-orange-50 dark:bg-orange-900/20',
    iconColor: 'text-orange-600 dark:text-orange-400',
    iconBg: 'bg-orange-100 dark:bg-orange-900/30',
    icon: 'M8 7h8m-8 5h8m-4-9v2m-4 14h8a2 2 0 002-2v-3a2 2 0 00-2-2H8a2 2 0 00-2 2v3a2 2 0 002 2zM7 10a2 2 0 11-4 0 2 2 0 014 0zm14 0a2 2 0 11-4 0 2 2 0 014 0z',
  },
];

const MobileTravel = () => {
  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-950 pb-8">
      <div style={{ height: 'env(safe-area-inset-top)' }} />

      {/* Gradient header */}
      <div className="bg-gradient-to-br from-primary-dark to-primary px-5 pt-6 pb-8 rounded-b-3xl">
        <Link to="/" className="text-white/70 text-sm inline-flex items-center mb-3">
          <svg className="w-4 h-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
          </svg>
          Back
        </Link>
        <div className="w-14 h-14 bg-white/15 rounded-2xl flex items-center justify-center mb-3 ring-1 ring-white/20">
          <svg className="w-7 h-7 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M9 20l-5.447-2.724A1 1 0 013 16.382V5.618a1 1 0 011.447-.894L9 7m0 13l6-3m-6 3V7m6 10l4.553 2.276A1 1 0 0021 18.382V7.618a1 1 0 00-.553-.894L15 4m0 13V4m0 0L9 7" />
          </svg>
        </div>
        <h1 className="font-display text-2xl font-bold text-white">Travel & Accommodation</h1>
        <p className="text-white/60 text-sm mt-1">Everything you need to plan your trip</p>
      </div>

      {/* Travel cards */}
      <div className="px-5 mt-6 space-y-4">
        {TRAVEL_CARDS.map((card) => (
          <div key={card.title} className={`rounded-2xl p-5 ${card.color}`}>
            <div className={`w-12 h-12 rounded-xl ${card.iconBg} flex items-center justify-center mb-3`}>
              <svg className={`w-6 h-6 ${card.iconColor}`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d={card.icon} />
              </svg>
            </div>
            <h2 className="font-display text-lg font-bold text-gray-900 dark:text-white mb-1">{card.title}</h2>
            <p className="text-gray-500 dark:text-gray-400 text-sm mb-3">{card.desc}</p>
            <a
              href={card.link}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center text-primary font-semibold text-sm"
            >
              {card.linkText}
              <svg className="w-4 h-4 ml-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14 5l7 7m0 0l-7 7m7-7H3" />
              </svg>
            </a>
          </div>
        ))}
      </div>

      {/* Info section */}
      <div className="px-5 mt-6">
        <div className="bg-white dark:bg-gray-800 rounded-2xl p-5 shadow-card">
          <h2 className="font-display text-lg font-bold text-gray-900 dark:text-white mb-3">Travel Tips</h2>
          <ul className="space-y-2.5">
            <li className="flex items-start gap-2">
              <svg className="w-5 h-5 text-primary flex-shrink-0 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" /></svg>
              <span className="text-gray-600 dark:text-gray-400 text-sm">Book early for the best rates and availability</span>
            </li>
            <li className="flex items-start gap-2">
              <svg className="w-5 h-5 text-primary flex-shrink-0 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" /></svg>
              <span className="text-gray-600 dark:text-gray-400 text-sm">Check visa requirements if traveling internationally</span>
            </li>
            <li className="flex items-start gap-2">
              <svg className="w-5 h-5 text-primary flex-shrink-0 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" /></svg>
              <span className="text-gray-600 dark:text-gray-400 text-sm">Save your confirmation details for easy check-in</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default MobileTravel;
